import React, { FC, PropsWithChildren } from 'react';

const TransLineBreak: FC<PropsWithChildren> = () => <br />;

export default TransLineBreak;
